<template>
  <el-scrollbar :native="false" style="width: 100%;height: 100%;">
    <el-main>
      <el-card>
        <template #header>发票抬头</template>
        <div>
          <el-input style="width: 200px; margin-right: 5px" placeholder="发票编号" prefix-icon="el-icon-search"
            v-model="searchForm.invoiceId"/>
            <el-input style="width: 200px; margin-right: 5px" placeholder="发票抬头"
            v-model="searchForm.invoiceTitle"/>
          <el-date-picker style="margin-right: 5px" align="right" type="daterange" end-placeholder="结束日期"
            range-separator="至" start-placeholder="开始日期" unlink-panels v-model="selectTimeList"
            value-format="yyyy-MM-dd" />
          <el-button @click="handleConfirmClick" size="small" style="width:120px" type="primary">确定</el-button>
          <el-button @click="readAllClick" size="small" style="width:120px" type="warning">一建已读</el-button>
        </div>
      </el-card>

      <el-card style="margin-top:20px">
          <template #header>
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <span>发票列表</span>
                <el-button type="primary" size="small" @click="exportInvoiceAction">导出发票</el-button>
              </div>
              
          </template>
          <el-table ref="multipleTable" :data="invoiceList" tooltip-effect="dark" border @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="50" align="center"/>
              <el-table-column prop="orderIds" label="订单号" align="center" width="220">
                  <template slot-scope="{row}">
                      <div>
                        <span v-if="row.hasRead == 0" style="color: red; font-size: 20px;">* </span>
                        <span>{{ row.orderIds }}</span>
                      </div>
                  </template>
              </el-table-column>
        <el-table-column v-for="(item, index) in invoiceListTitle" :key="index" :prop="item.propertyName"
          :label="item.name" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="item.propertyName == 'invoiceType'">
              {{ scope.row[item.propertyName] == 1 ? '单位' : '个人' }}
            </span>
            <span v-else-if="item.propertyName == 'invoiceMakeOutStatus'">
              {{
                scope.row[item.propertyName] == 0 ? '开票中' :
                scope.row[item.propertyName] == 1 ? '已开' :
                  scope.row[item.propertyName] == 2 ? '完成' :
                    scope.row[item.propertyName] == 3 ? '重开' :
                      scope.row[item.propertyName] == 4 ? '已废弃' :
                        scope.row[item.propertyName] == 5 ? '未支付' :
                          scope.row[item.propertyName] == 9 ? '退票中' :
                            scope.row[item.propertyName] == 10 ? '已退票' :
                              '未知'
              }}
            </span>
            <span v-else-if="item.propertyName == 'invoiceMoney'">
              {{ (scope.row[item.propertyName]/100).toFixed(2)}}
            </span>
            <span v-else>
              {{ scope.row[item.propertyName] ? scope.row[item.propertyName] : '' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" width="170" align="center" label="操作">
            <template slot-scope="scope">
                <el-button size="mini" @click="lookDetail(scope.row)">查看详情</el-button>
                <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            </template>
        </el-table-column>
      </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                        :page-sizes="[5, 10, 15, 20, 25, 30, 50, 100]" :page-size="listPageSize" style="margin-top:20px"
                        layout="total, sizes, prev, pager, next, jumper" :total="listPageTotal">
          </el-pagination>
      </el-card>
     
      
    </el-main>
    <invoiceDetailDialog @update="requestInvoiceList" ref="invoiceDialog"></invoiceDetailDialog>
  </el-scrollbar>
</template>

<script>
import invoiceDetailDialog from '@/components/invoiceDetailDialog.vue'
import utils from '@/utils/utils'
export default {
  name: "backInvoiceTitle",
  components: {
    invoiceDetailDialog
  },
  data() {
    return {
      inputKeyword: '',
      valueEnclosure: '',
      listPageSize: 10,//单页数据数
      listPageTotal: 0,//总数据数量
      currentPage: 1,//当前页
      invoiceListTitle: [
        {
          name: '开票状态',
          propertyName: 'invoiceMakeOutStatus'
        },
        {
          name: '发票类型',
          propertyName: 'invoiceType'
        },
        {
          name: '发票抬头',
          propertyName: 'invoiceTitle'
        },
        {
          name: '税号',
          propertyName: 'invoiceDutyParagraph'
        },
        {
          name: '开户行及账户',
          propertyName: 'invoiceBankAccount'
        },
        {
          name: '地址和电话',
          propertyName: 'invoiceAddressPhone'
        },
        {
          name: '发票金额',
          propertyName: 'invoiceMoney'
        },
        {
          name: '创建时间',
          propertyName: 'invoiceCreateTime'
        }
      ],
      invoiceList: [],
      // 搜索的表单
      searchForm: {
        invoiceTitle: undefined,
        invoiceId: '',
      },
      // 选择的时间列表
      selectTimeList: [],
      selectDatas: [],
    }
  },
  mounted() {
    let loading = this.$loading(this.utils.defaultLoadingOptions);
    this.requestInvoiceList().then(() => {
      loading.close();
    }, err => {
      console.log(err)
    })
  },
  methods: {
    async readAllClick() {
      if (!this.$store.state.invoiceNum) {
        this.$message.warning('暂无未读发票')
        return
      }
      this.$confirm('此操作会将所有未读发票置为已读状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {

        let { status } = await this.$request.clearInvoiceMessage()
        if (status !== 200) {
          this.$message.error('操作失败')
          return
        }
        this.$message.success('操作成功')
        this.requestInvoiceList()
        this.$store.dispatch('changeInvoiceNum')
      }).catch(() => {
      })
    },
    // 确定搜索按钮点击事件
    handleConfirmClick() {
      // if (this.selectTimeList && this.selectTimeList?.length !== 0) {
      //   const [startTime, endTime] = this.selectTimeList
      //   this.searchForm = {...this.searchForm, ...{startTime, endTime}}
      // }
      this.searchForm.startTime = this.selectTimeList && this.selectTimeList[0] || null
      this.searchForm.endTime = this.selectTimeList && this.selectTimeList[1] || null
      this.requestInvoiceList()
    },
    lookDetail({ invoiceId }) {
      this.$refs.invoiceDialog.open(invoiceId)
    },
    handleEdit(index, row) {
      console.log(index, row);
      let { href } = this.$router.resolve({
        name: 'backInvoiceTitleEdit',
        query: {
          id: row.invoiceId
        }
      });
      window.open(href, '_blank')
    },
    handleSizeChange(val) {
      let loading = this.$loading(this.utils.defaultLoadingOptions);
      this.listPageSize = val;
      this.requestInvoiceList().then(() => {
        loading.close()
      })
    },
    handleCurrentChange(val) {
      let loading = this.$loading(this.utils.defaultLoadingOptions);
      this.currentPage = val;
      this.requestInvoiceList().then(() => {
        loading.close()
      })
    },
    handleSelectionChange(val){
      this.selectDatas = val;
      console.debug(this.selectDatas);
    },
    async exportInvoiceAction(){
      let params = {}
      if(this.selectDatas.length > 0){
        
        let selectIds = [];
        for (const itme in this.selectDatas) {
          if (Object.hasOwnProperty.call(this.selectDatas, itme)) {
            const element = this.selectDatas[itme];
            selectIds.push(element.invoiceId);
          }
        }
        console.debug('导出选中发票', selectIds);
        
        params.invoiceIds = selectIds.join(); 
      }else{
        console.debug('导出搜索发票');
        params.page = this.currentPage;
        params.size = this.listPageSize;
        params.invoiceId = this.searchForm.invoiceId || null;
        params.invoiceTitle = this.searchForm.invoiceTitle || undefined,
        params.startTime = this.searchForm.startTime || null;
        params.endTime = this.searchForm.endTime || null;
      }
      let res = await this.$request.exportInvoice(params);
      let blob = new Blob([res], { type: 'application/vnd.ms-excel;charset=UTF-8' });
      let date = new Date();
      const fileName = `发票数据导出-${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}.xlsx`
      utils.saveAs(blob, `${fileName}`)
    },
    requestInvoiceList() {
      return new Promise((resolve, reject) => {
        this.$request.invoiceList({
          page: this.currentPage,
          size: this.listPageSize,
          invoiceId: this.searchForm.invoiceId || null,
          invoiceTitle: this.searchForm.invoiceTitle || undefined,
          startTime: this.searchForm.startTime || null,
          endTime: this.searchForm.endTime || null,
        }).then(res => {
          console.log(res)
          if (res.status === 200) {
            resolve(res)
            res.data.list.forEach(item => {
              item.orderIds = item.orderIds.join();
            });
            this.invoiceList = res.data.list;
            this.listPageTotal = res.data.total;
          } else {
            this.requestError(res.status, res.message)
          }

        }, err => {
          reject(err)
          this.requestFail(err);
        })
      })

    }
  }
}
</script>

<style scoped>
.search-wrap {
  padding: 20px;
}

.pagination-wrap {
  margin-top: 50px;
}
</style>